import React from 'react';
import Switch from '@material-ui/core/Switch';

export interface SwitchesProps {
    checked?: boolean;    
    onChange: (value: boolean) => void;
}




const Switches = (props: SwitchesProps) => {
  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: props.checked,
  });

  React.useEffect(() => {
    setState({ ...state, ["checkedB"]: props.checked! });
  },[props.checked]);
  

  function handleChange(e) {
    if (e && e.target) {
        setState({ ...state, [e.target.name]: e.target.checked });
        props.onChange(e.target.checked);
    }
}

  return (
    <Switch
        checked={state.checkedB}
        onChange={handleChange}
        color="primary"
        name="checkedB"        
        inputProps={{ 'aria-label': 'primary checkbox' }}
    />
  );
}


export default Switches;